import { TvChannelViewOption } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

interface ChannelPlaybackHandlers {
    onNotAvailable: () => void;
    onNeedAuth: () => void;
    onShowModal: () => void;
    onPlay: () => void;
}

export function resolveChannelPlayback(
    viewOption: TvChannelViewOption | undefined | null,
    isAuthorized: boolean,
    handlers: ChannelPlaybackHandlers
) {
    const isWatchable = viewOption?.isWatchable;
    const isPurchased = viewOption?.isPurchased;
    const type = viewOption?.type;

    if (!isWatchable) {
        return;
    }

    if (type === 'SUBSCRIPTION' && !isAuthorized) {
        handlers.onShowModal();
        return;
    }

    if (!isAuthorized) {
        handlers.onNeedAuth();
        return;
    }

    if (!isPurchased) {
        handlers.onShowModal();
        return;
    }

    handlers.onPlay();
}
